import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import ShoppingCartApi from '@/api/shoppingCart';
import auth from '@/utils/auth';
var state = {
  noticeData: {
    storeNo: '',
    noticeType: '',
    list: []
  },
  // 通知数据
  cartAmount: '' // 购物车数量

};
var mutations = {
  SET_NOTICE_DATA: function SET_NOTICE_DATA(state, payload) {
    state.noticeData = _objectSpread(_objectSpread({}, state.noticeData), payload);
  },
  SET_CART_AMOUNT: function SET_CART_AMOUNT(state, payload) {
    state.cartAmount = payload;
  }
};
var actions = {
  setNoticeData: function setNoticeData(_ref, payload) {
    var commit = _ref.commit;
    commit('SET_NOTICE_DATA', payload);
  },
  setCartAmount: function setCartAmount(_ref2) {
    var commit = _ref2.commit;

    if (auth.getToken()) {
      ShoppingCartApi.cartCount().then(function (res) {
        var amount = (res.data.cartCount || 0) > 99 ? 99 : res.data.cartCount || 0;
        commit('SET_CART_AMOUNT', amount);
      });
    } else {
      commit('SET_CART_AMOUNT', 0);
    }
  }
};
var getters = {
  getNoticeData: function getNoticeData(state) {
    return state.noticeData;
  },
  getCartAmount: function getCartAmount() {
    return state.cartAmount;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};